export class NCM {
  constructor() {
    this.id = 0;
    this.codigo = '';
    this.descricao = '';
  }
}